import PropTypes from "prop-types";

const Header = ({ icon: Icon, title, description, rightSection }) => {
  return (
    <div className="sm:flex sm:items-center">
      <div className="sm:flex-auto">
        <div className="flex items-center gap-2">
          {Icon && <Icon className="h-6 w-6 text-gray-500" />}
          <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        </div>
        {description && (
          <p className="mt-2 text-sm text-gray-700">{description}</p>
        )}
      </div>
      {rightSection && (
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">{rightSection}</div>
      )}
    </div>
  );
};

Header.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  rightSection: PropTypes.node,
};

export default Header;
